import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const makeWorkExperienceDialogueStyles = makeStyles()((theme: Theme) => ({
  dialogContainer: {
    minWidth: '890px',
  },
  dialogContent: {
    paddingTop: 0,
    overflow: 'hidden',
    'overflow-y': 'scroll',
  },
  MuiCircularProgressRoot: {
    left: '50%',
    position: 'absolute',
    top: '50vh',
  },
  checkBoxContainer: {
    marginBottom: '-30px',
  },
  checkBoxInput: {
    paddingTop: '24px !important',
  },
}));
